import { FutureFlowEntity, FutureFlowCreateRequest, Instrument, Portfolio } from "../domain/entities/DashboardEntity";


export const enrichFutureFlow = (
    request: FutureFlowCreateRequest,
    id: string,
    context: {
        portfolios?: Portfolio[];
        instruments?: Instrument[];
    }
): FutureFlowEntity | null => {
    const {
        portfolios = [],
        instruments = [],
    } = context;

    const portfolio = portfolios.find((p) => p.id.toString() === request.portfolio);
    const instrument = instruments.find((ins) => ins.id.toString() === request.instrument);


    if (!portfolio || !instrument) return null;

    const [year, month, day] = request.flowDate.split("-").map(Number);
    const date = new Date(year, month - 1, day);


    return {
        id,
        portfolio,
        instrument,
        flowDate: new Date(date),
        value: request.value,
    };
}